export default __webpack_public_path__ + "static/media/Brainart_LoginFrontend_Default.02520782.png";